import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrackEventViewDirective } from './track-event-view.directive';
import { TrackEventDirective } from './track-event.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [TrackEventDirective, TrackEventViewDirective],
  exports: [TrackEventDirective, TrackEventViewDirective]
})
export class AnalyticsModule {}

export * from './track-event-view.directive';
export * from './track-event.directive';
